export const centsFormat = '$0,0.00'
export const dollarsFormat = '$0,0'

export const isDollar = (amount?: string) => {
  return (amount?.startsWith('$') && !amount?.includes('-')) || false
}

export const isDollarRange = (amount?: string) => {
  return (amount?.startsWith('$') && amount?.includes('-')) || false
}

export const isPercentage = (amount?: string) => {
  return amount?.endsWith('%') || false
}
